/**
 * Mocked recent resolved ticket data for preview/mocked flows.
 * Used when the chatbot is in mocked mode to show recent resolved ticket on home page.
 */

import type { ListTicketDetail, EntityReview } from '@/common/api/models.pleased';

/**
 * Create mocked recent resolved ticket data
 */
export const createMockedRecentResolvedTicket = (): {
  ticket: ListTicketDetail;
  reviews: EntityReview[];
  ticketReviews: EntityReview[];
} => ({
  ticket: {
    id: 98765,
    subject: 'Login Issue - Unable to Access Account',
    emailSubject: 'Login Issue - Unable to Access Account',
    priority: 'MEDIUM',
    status: 'RESOLVED',
    requesterId: 12345,
    assigneeId: 67890,
    groupId: 1,
    brandId: 1,
    sourceId: 1,
    categoryId: 5,
    recipientAddress: null,
    receivedAddress: null,
    emailCCIds: null,
    slaTimestamp: null,
    rating: null,
    isAgentViewed: true,
    requesterName: 'John Doe',
    requesterPhone: '+1234567890',
    requesterEmail: 'john.doe@example.com',
    agentName: 'Support Agent',
    agentEmail: 'support@example.com',
    groupName: 'Customer Support',
    extraFields: null,
    comments: null,
    new: false,
    createdBy: 12345,
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 2), // 2 days ago
    updatedAt: new Date(Date.now() - 1000 * 60 * 60 * 24), // 1 day ago
    updatedBy: 67890,
  },
  reviews: [],
  ticketReviews: [],
});
